module.exports = __webpack_public_path__ + "static/media/expand.6cad6e1e.svg";